import { Component } from '@angular/core';

@Component({
  selector: 'app-message-esn',
  templateUrl: './message-esn.component.html',
  styleUrls: ['./message-esn.component.css']
})
export class MessageEsnComponent {

}
